import AppRouter from "./routes";
import { CartProvider } from "./components/UI/Buttons/CartContext";
import ReactPixel from "react-facebook-pixel";
import { useEffect } from "react";
import { AuthProvider } from "@/data/context/authContext";
import { Toaster } from "sonner";
import { disableImageDefaultOpeningOnDiffTabInSafari } from "./utils/safariFixes";
import { APIProvider } from "@vis.gl/react-google-maps";
// import ROUTES from "./data/Routes";

// const options = {
//   autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
//   debug: false, // enable logs
// };

const App = () => {
  useEffect(() => {
    disableImageDefaultOpeningOnDiffTabInSafari();

    if (!import.meta.env.VITE_META_PIXEL_ID)
      console.warn("META PIXEL IS DISABLED");

    ReactPixel.init(import.meta.env.VITE_META_PIXEL_ID);
    ReactPixel.pageView(); // For tracking page view
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
          <Toaster richColors />
          <AppRouter />
        </APIProvider>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
